import DATE_CONSTANTS from 'trustar-2.0/utils/Date.constants';

export const PHISHING_TRIAGE_ENCLAVE_TEMPLATE_NAME = 'Phishing Triage';

export const PHISHING_SCORE_VALUES = {
  UNRESOLVED: 'UNRESOLVED',
  CONFIRMED: 'CONFIRMED',
  IGNORED: 'IGNORED',
};
export const TRIAGE_STATUS_TO_PHISHING_TAG = {
  UNRESOLVED: 'phishing/unresolved',
  CONFIRMED: 'phishing/confirmed',
  IGNORED: 'phishing/ignored',
};

export const TRIAGE_STATUSES = {
  UNKNOWN: -1,
  BENIGN: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};

export const TRIAGE_STATUSES_TO_NAMES = {
  '-1': 'UNKNOWN',
  '0': 'BENIGN',
  '1': 'LOW',
  '2':  'MEDIUM',
  '3': 'HIGH',
};

export const TRIAGE_STATUS_OPTIONS = Object.values(TRIAGE_STATUSES);
export const PHISHING_STATUS_OPTIONS = Object.values(PHISHING_SCORE_VALUES);

export const TRIAGE_ENDPOINT = '/services/triage/submissions';

export const DOWNLOAD_INDICATOR_CSV_ENDPOINT = '/services/triage/export-indicators.csv';
export const PHISHING_INDICATORS_CSV_FILENAME = 'phishing-report.csv';

// Currently the page size is fixed on the BE to 25, but this may change
export const DEFAULT_PAGE_SIZE = 25;



// WEBPACK FOOTER //
// ./src/app/modules/triage/constants.js